import React, { useEffect } from 'react';
import { fetchAgeRange, fetchAssetType, fetchCubicCapacitymaster, fetchLocationFromMaster, fetchMachineType, fetchOccupancy, fetchOccupation, fetchOtherSettings, fetchProductRate, fetchProjectTypeMaster, fetchRiskfactorMaster, fetchSectionmaster, fetchVehicleType, fetchVoyageData, setDataSuccess } from 'src/features/staticDataSlice';
import { useDispatch, useSelector } from 'react-redux';
import AnimalList from './AnimalListSec/AnimalList';
import EmployeeList from './EmployeeListSec/EmployeeList';
import AssetList from './AssetListSec/AssetList';
import SumInsuredLabelvaluepair from './SumInsuredLabelvaluepair';
import {
  selectEndorsmentFormData,
  selectEndorsmentScreenNumber,
  selectPolicyDetails
} from 'src/features/rfqDataSlice';
import SumInsuredLabelvaluepairEditable from './SumInsuredLabelvaluepairEditable';

function SumInsured() {
  const dispatch = useDispatch();
  const endorsementFormData = useSelector(selectEndorsmentFormData);
  const endorsementScreenNumber = useSelector(selectEndorsmentScreenNumber);
  const policyDetails = useSelector(selectPolicyDetails);
  const customerId = policyDetails?.retailCustomerId || policyDetails?.corporateCustomerId || null;
  const customerType = policyDetails?.customerType?.toLowerCase() || null;
  const sumInsuredSections = policyDetails?.policySumInsuredSections || [];

  const includedSectionIds = endorsementFormData?.sumInsuredSectionData
    ? Object.keys(endorsementFormData.sumInsuredSectionData)
    : [];

  const productId = policyDetails?.placementSlip?.policyProduct?.id;
  useEffect(() => {
    if (productId) {
      fetchVehicleType(productId).then(data => dispatch(setDataSuccess({ dataType: 'vehicleType', data })))
      fetchAgeRange(productId).then(data => dispatch(setDataSuccess({ dataType: 'ageRange', data })))
      fetchMachineType(productId).then(data => dispatch(setDataSuccess({ dataType: 'machineType', data })))
      fetchAssetType(productId).then(data => dispatch(setDataSuccess({ dataType: 'assetType', data })))
      fetchOccupancy(productId).then(data => dispatch(setDataSuccess({ dataType: 'occupancy', data })))
      fetchOccupation(productId).then(data => dispatch(setDataSuccess({ dataType: 'occupation', data })))
      fetchProductRate(productId).then(data => dispatch(setDataSuccess({ dataType: 'productRate', data })));
      fetchOtherSettings(productId).then(data => dispatch(setDataSuccess({ dataType: 'othersSettings', data })));
      fetchVoyageData(productId).then(data => dispatch(setDataSuccess({ dataType: 'voyage', data })));
      fetchSectionmaster(productId).then(data => dispatch(setDataSuccess({ dataType: 'sectionMaster', data })));
      fetchCubicCapacitymaster(productId).then(data => dispatch(setDataSuccess({ dataType: 'cubicCapacity', data })));
      fetchProjectTypeMaster(productId).then(data => dispatch(setDataSuccess({ dataType: 'projectType', data })));
      fetchRiskfactorMaster(productId, 'ageRiskFactor/getAgeList', 'Age').then(data => dispatch(setDataSuccess({ dataType: 'age', data })));
      fetchRiskfactorMaster(productId, 'description/getDescriptionList', 'Description').then(data => dispatch(setDataSuccess({ dataType: 'description', data })));
      fetchRiskfactorMaster(productId, 'boilerType/getboilerTypeList', 'boilerType').then(data => dispatch(setDataSuccess({ dataType: 'boilerType', data })));
      fetchRiskfactorMaster(productId, 'type/getTypeList', 'Type').then(data => dispatch(setDataSuccess({ dataType: 'type', data })));
      fetchRiskfactorMaster(productId, 'stipulatedAge/getStipulatedAgeList', 'StipulatedAge').then(data => dispatch(setDataSuccess({ dataType: 'stipulatedAge', data })));
      fetchRiskfactorMaster(productId, 'indemnityPeriod/getIndemnityPeriodList', 'IndemnityPeriod').then(data => dispatch(setDataSuccess({ dataType: 'indemnityPeriod', data })));
      fetchRiskfactorMaster(productId, 'vehichle/listVehicleMake', 'vehicleMake').then(data => dispatch(setDataSuccess({ dataType: 'vehicleMake', data })));
      fetchRiskfactorMaster(productId, 'riskFactor/getRiskFactorByProductId', 'testingPeriod').then(data => dispatch(setDataSuccess({ dataType: 'testingPeriod', data })));
      fetchRiskfactorMaster(productId, 'riskFactor/getRiskFactorByProductId', 'territory').then(data => dispatch(setDataSuccess({ dataType: 'territory', data })));
      fetchRiskfactorMaster(productId, 'riskFactor/getRiskFactorByProductId', 'jurisdiction').then(data => dispatch(setDataSuccess({ dataType: 'jurisdiction', data })));
      fetchRiskfactorMaster(productId, 'riskFactor/getRiskFactorByProductId', 'basisOfValuation').then(data => dispatch(setDataSuccess({ dataType: 'basisOfValuation', data })));
      fetchRiskfactorMaster(productId, 'riskFactor/getRiskFactorByProductId', 'riskCovered').then(data => dispatch(setDataSuccess({ dataType: 'riskCovered', data })));
      fetchRiskfactorMaster(productId, 'riskFactor/getRiskFactorByProductId', 'modeOfTransit').then(data => dispatch(setDataSuccess({ dataType: 'modeOfTransit', data })));
      fetchRiskfactorMaster(productId, 'riskFactor/getRiskFactorByProductId', 'conveyance').then(data => dispatch(setDataSuccess({ dataType: 'conveyance', data })));
      fetchRiskfactorMaster(productId, 'riskFactor/getRiskFactorByProductId', 'projectPeriodRf').then(data => dispatch(setDataSuccess({ dataType: 'projectPeriod', data })));
      fetchRiskfactorMaster(productId, 'riskFactor/getRiskFactorByProductId', 'packingRf').then(data => dispatch(setDataSuccess({ dataType: 'packingRf', data })));

    }
  }, [dispatch, productId]);

  useEffect(() => {
    if (customerId) {
      fetchLocationFromMaster(customerId, 'customerLocation/list', customerType).then(data =>
        dispatch(setDataSuccess({ dataType: 'location', data }))
      );
    }
  }, [customerId]);

  return (
    <>
      {sumInsuredSections && (
        <div id="sumInsuredBox">

          {sumInsuredSections.map(sumInsuredData => {
            const sectionId = String(sumInsuredData?.id);

            // Skip this section in endorsementScreenNumber 2 if section ID not included
            if (
              endorsementScreenNumber === 2 &&
              !includedSectionIds.includes(sectionId)
            ) {

              return null;
            }

            return (
              <React.Fragment key={sectionId}>
                {sumInsuredData?.type === 'labelValuePairList' ? (
                  endorsementScreenNumber === 2 ? (
                    <SumInsuredLabelvaluepairEditable policyDetails={sumInsuredData} />
                  ) : (
                    <SumInsuredLabelvaluepair policyDetails={sumInsuredData} />
                  )
                ) : sumInsuredData?.type === 'employeeList' ? (
                  <EmployeeList sumInsuredData={sumInsuredData} productId={productId} />
                ) : sumInsuredData?.type === 'assetList' ? (
                  <AssetList sumInsuredData={sumInsuredData} productId={productId} />
                ) : sumInsuredData?.type === 'animalList' ? (
                  <AnimalList sumInsuredData={sumInsuredData} productId={productId} />
                ) : null}
              </React.Fragment>
            );
          })}
        </div>
      )}
    </>
  );
}

export default SumInsured;
